import { FC } from "react";
import type { RaffleTier } from "entities/wheel-raffle";
import { FormInput } from "shared/ui";
import type { CreateRaffleForm } from "../model/useCreateRaffle";
import { DurationField } from "./DurationField";
import { LabeledInput } from "./LabeledInput";
import { PairsPicker } from "./PairsPicker";
import { TierThresholdPicker } from "./TierThresholdPicker";

import styles from "./CreateWheelRaffleForm.module.css";

interface Props {
  form: CreateRaffleForm;
  symbols: string[];
  tiers: RaffleTier[];
}

// Сколько идёт розыгрыш и что нужно для участия.
export const RulesFields: FC<Props> = ({ form, symbols, tiers }) => {
  const { values, errors, setValue, isSubmitting, limits } = form;

  return (
    <>
      <div className={styles.row}>
        <DurationField
          value={values.durationSec}
          limits={limits}
          error={errors.durationSec}
          onChange={(seconds) => setValue("durationSec", seconds)}
        />
        <PairsPicker
          symbols={symbols}
          value={values.symbols}
          error={errors.symbols}
          disabled={isSubmitting}
          onChange={(next) => setValue("symbols", next)}
        />
      </div>
      <div className={styles.row}>
        <LabeledInput
          label="Min. trading volume, USDT"
          hint="Turnover on the selected pairs needed to participate."
        >
          <FormInput
            inputMode="decimal"
            placeholder="100.00"
            value={values.volume}
            error={errors.volume}
            onValueChange={(value) => setValue("volume", value)}
            disabled={isSubmitting}
          />
        </LabeledInput>
        <TierThresholdPicker
          tiers={tiers}
          value={values.minTier}
          error={errors.minTier}
          disabled={isSubmitting}
          onChange={(tierCode) => setValue("minTier", tierCode)}
        />
      </div>
    </>
  );
};
